export const waitMs = (ms = 100) => new Promise((resolve) => setTimeout(resolve, ms))
